<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <div class="banner">
      <img src="../../assets/img/jieju/zf_banner.png" class="img_banner" alt />
      <div class="banner_1">
        <div class="banner_left">
          <img src="../../assets/img/guanyu/sh_logo.png" alt />
          <p>政务“互联网+”服务商 民营企业服务平台建设运营</p>
          <p style="font-size:14px;color:#FFFFFF;width:291px;line-height:30px;">
            用“企业-平台-部门”互通方式提高服务效率
            用互联网技术解决商会管理和服务难问题
            用大数据解决企业商机人脉等信息不对称问题
          </p>
        </div>
      </div>
      <div class="banner_2">
        <div class="banner_2_1">
          <ul>
            <li>
              <p>建立服务型政务</p>
              <p class="banner_2_1p">解决实际问题，服务民营企业</p>
              <p class="banner_2_1p">促进民营经济发展</p>
            </li>
            <li>
              <p>建立服务型政务</p>
              <p class="banner_2_1p">解决实际问题，服务民营企业</p>
              <p class="banner_2_1p">促进民营经济发展</p>
            </li>
            <li style="border-right:1px solid #fff;">
              <p>建立服务型政务</p>
              <p class="banner_2_1p">解决实际问题，服务民营企业</p>
              <p class="banner_2_1p">促进民营经济发展</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="conent">
      <div class="conent_1">
        <h1>政务类“互联网+企业服务”解决方案</h1>
        <p class="conent_1_p">
          帮助各地工商联建设服务民营企业及商会的线上民营企业服务平台及线下民营企业服务中心，
          赋能商会信息化建设，助力区域民营经济发展。
        </p>
        <p class="conent_1_p" style="margin-bottom: 39px;">让当地的企业体验到“扫码进入，一键求助，一呼百应”的政企互通一站式服务体验。</p>
        <div class="conent_nive">
          <ul>
            <li>
              <img src="../../assets/img/jieju/zf_img_bg01.png" alt />
              <div class="conent_nive_p">
                <p>民营企业服务平台</p>
                <p>整合政府资源和社会资源，有效解决政府服务众多民营企业不到位、民营企业间与社会资源信息不对等难点、痛点问题。</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/zf_img_bg02.png" alt />
              <div class="conent_nive_p">
                <p>民营企业服务中心</p>
                <p>筛选优质企业服务类机构入驻，整合优质企业服务资源，提供政策解读、问题解答、政企资源及企业间资源对接、培训等一系列服务。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="conent1">
      <div class="content1_1">
        <h1>民营企业服务平台<span style="color:#6DF4FF;">六大服务</span></h1>
        <p class="conent_1_p1">以服务外包形式建立专业的运营服务团队</p>
        <p class="conent_1_p1">搭建专业用户运营、数据运营、内容运营、产品运营、市场运营体系</p>
        <p class="conent_1_p1" style="margin-bottom: 39px;">以内容引导帮助工商联及商会提高服务能力，促进民营企业经济发展</p>
        <div class="conent_1_div">
          <img src="../../assets/img/jieju/zf_img_service.png" alt="">
          <div class="conent_1_div_1">
            <ul>
              <li>
                <p style="font-size:18px;color:#6DF4FF;font-weight:600;">政务服务</p>
                <p class="conent_1_div_p">为企业提供政务服务窗口，建立政企交流</p>
                <p class="conent_1_div_p1">通道，形成问答数据报告</p>
              </li>
              <li style="margin-right:60px;">
                <p style="font-size:18px;color:#6DF4FF;font-weight:600;">商会服务</p>
                <p class="conent_1_div_p">用户可查看所属商会的相关信息及活动等</p>
                <p class="conent_1_div_p1">也可申请加入其它商会</p>
              </li>
              <li>
                <p style="font-size:18px;color:#6DF4FF;font-weight:600;">采购</p>
                <p class="conent_1_div_p">比传统采购管理更精细化、流程化，借助</p>
                <p class="conent_1_div_p1">信息化和互联网手段提升采购管理水平</p>
              </li>
            </ul>
          </div>
          <div class="conent_1_div_2">
            <ul>
              <li>
                <p style="font-size:18px;color:#6DF4FF;font-weight:600;">政务服务</p>
                <p class="conent_1_div_p">为企业提供政务服务窗口，建立政企交流</p>
                <p class="conent_1_div_p1">通道，形成问答数据报告</p>
              </li>
              <li style="margin-left:60px;">
                <p style="font-size:18px;color:#6DF4FF;font-weight:600;">商会服务</p>
                <p class="conent_1_div_p">用户可查看所属商会的相关信息及活动等</p>
                <p class="conent_1_div_p1">也可申请加入其它商会</p>
              </li>
              <li>
                <p style="font-size:18px;color:#6DF4FF;font-weight:600;">采购</p>
                <p class="conent_1_div_p">比传统采购管理更精细化、流程化，借助</p>
                <p class="conent_1_div_p1">信息化和互联网手段提升采购管理水平</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="content2">
      <div class="content2_1">
        <h1>民营企业服务中心 <span style="color:#007BFF;">五大功能</span></h1>
        <p class="conent_1_p2">
          定期由运营协助举办有关政策解读、法律讲堂、企业经营管理等 一系列企业经营服务相关会议及培训讲座 
        </p>
        <p class="conent_1_p2" style="margin-bottom: 80px;">帮助当地投资创业的企业发展，助力招商引资。</p>
        <ul class="content2_1_ul">
          <li>
            <img src="../../assets/img/jieju/zf_img_function01.png" alt="">
            <p style="color:#FFF;">营商环境展示</p>
          </li>
          <li>
            <img src="../../assets/img/jieju/zf_img_function02.png" alt="">
            <p>活动</p>
            <p style='margin:0;color:#666666;font-size:14px;font-weight:400;'>培训、私董会、路演等</p>
          </li>
          <li>
            <img src="../../assets/img/jieju/zf_img_function03.png" alt="">
            <p>问题解答</p>
          </li>
          <li>
            <img src="../../assets/img/jieju/zf_img_function04.png" alt="">
            <p>资源对接</p>
            <p style='margin:0;color:#666666;font-size:14px;font-weight:400;'>政府+企业</p>
          </li>
          <li>
            <img src="../../assets/img/jieju/zf_img_function05.png" alt="">
            <p>服务机构入驻</p>
          </li>
        </ul>
      </div>
    </div>
    
    <div class="content3">
      <div class="content3_1">
        <img src="../../assets/img/jieju/zf_img_function_picture.png" alt="">
      </div>
    </div>

    <div class="content4">
      <div class="content4_1">
        <h1>案例展示</h1>
        <div class="content_img">
          <img src="../../assets/img/jieju/case_btn_prev_nor.png" alt="">
          <img src="../../assets/img/jieju/case_btn_next_nor.png" alt="">
        </div>
        <ul class="content4_ul">
          <li>
            <img src="../../assets/img/jieju/case_bg.png" alt="" class="posit">
            <div class="content4_ul_div">
              <img src="../../assets/img/jieju/case_img01.png" alt="">
              <p style="font-size:16px;">商企服小程序</p>
              <p>基于商会的一站式企业服务平台。项目现在已经研发完成并上线运营，已获得200万种子轮融资。 </p>
            </div>
          </li>
          <li>
            <img src="../../assets/img/jieju/case_bg.png" alt="" class="posit">
            <div class="content4_ul_div">
              <img src="../../assets/img/jieju/case_img02.png" alt="">
              <p style="font-size:16px;">商会后台</p>
              <p>商会免费使用，并获取会员在平台消费的5%服务佣金,帮助商会实现对会员的吸纳管理、内容发布等 </p>
            </div>
          </li>
          <li>
            <img src="../../assets/img/jieju/case_bg.png" alt="" class="posit">
            <div class="content4_ul_div">
              <img src="../../assets/img/jieju/case_img03.png" alt="">
              <p style="font-size:16px;">城市站后台</p>
              <p>对地级市或省会城市站进行内容维护，可管理服务商入驻信息及服务类目 </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="content_5">
      <p>免费咨询解决方案，解决服务难题</p>
      <p>联系电话：022-8821-9596</p>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: ""
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.banner {
  width: 100%;
  height: 750px;
  position: relative;
}

.img_banner {
  width: 100%;
  height: 100%;
}

.banner_1 {
  width: 1200px;
  height: 560px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}

.banner_left {
  width: 500px;
  height: auto;
  float: left;
}

.banner_left img {
  padding: 39px 0;
  margin-bottom: 50px;
}

.banner_left p {
  font-size: 40px;
  color: #fff;
  line-height: 60px;
  margin-bottom: 30px;
}

.banner_right {
  width: 370px;
  height: auto;
  float: right;
}

.banner_right_1 {
  width: 100%;
  height: 370px;
  margin-top: 80px;
  background: #fff;
  border-radius: 5px;
}

.banner_2 {
  width: 100%;
  height: 160px;
  background: rgba(4, 4, 15, 1);
  opacity: 0.45;
  position: absolute;
  bottom: 0;
}

.banner_2_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.banner_2_1 ul {
  display: flex;
}

.banner_2_1 ul li {
  width: 398px;
  height: 160px;
  border-left: 1px solid #ffffff;
}

.banner_2_1 ul li p {
  color: #ffffff;
}

.banner_2_1 ul li p:first-child {
  font-size: 20px;
  margin: 39px 0 0 40px;
  line-height: 30px;
}

.banner_2_1p {
  font-size: 14px;
  margin: 0 0 0 40px;
  line-height: 30px;
}

/* 内容 */

.conent {
  width: 100%;
  height: 500px;
}

.conent_1 {
  width: 1200px;
  height: 543px;
  margin: 0 auto;
}

.conent_1 h1 {
  text-align: center;
  margin: 96px 0 25px 0;
}

.conent_1_p {
  width: 645px;
  font-size: 14px;
  color: #666666;
  text-align: center;
  margin: 0 auto;
  line-height: 25px;
}

.conent_nive {
  width: 1200px;
  height: 208px;
}

.conent_nive ul li {
  width: 600px;
  height: auto;
  float: left;
  position: relative;
}

.conent_nive ul li img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.conent_nive_p {
  width: 321px;
  float: right;
  margin: 52px 50px 0 0;
  line-height: 28px;
}

.conent_nive_p p:first-child {
  font-size: 18px;
  color: #007bff;
  font-weight: bold;
}

.conent_nive_p p:last-child {
  font-size: 14px;
  color: #666;
}

.conent1 {
  width: 100%;
  height: 787px;
  background: #18184c;
}

.content1_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

.content1_1 h1{
  text-align: center;
  margin-top: 96px;
  margin-bottom: 22px;
  color: #fff;
}

.conent_1_p1{
  width: 645px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  margin: 0 auto;
  line-height: 25px;
}

.conent_1_p2{
  width: 392px;
  font-size: 14px;
  color: #666666;
  text-align: center;
  margin: 0 auto;
  line-height: 25px;
}

.conent_1_div{
  width: 100%;
  height: 513px;
  position: relative;
  overflow: hidden;
}

.conent_1_div img{
  position: absolute;
  top: 0;
  left: 0;
}

.conent_1_div_1{
  width: 500px;
  height: 457px;
  float: left;
}

.conent_1_div_2{
  width: 500px;
  height: 457px;
  float: right;
}

.conent_1_div_1 ul{
  width: 350px;
}

.conent_1_div_1 ul li p{
  float: right;
  line-height: 30px;
}

.conent_1_div_p{
  width: 252px;
  color: #fff;
  font-size: 14px;
}

.conent_1_div_p1{
  color: #fff;
  font-size: 14px;
}

.conent_1_div_1 li{
  width: 261px;
  height: 80px;
  margin-top: 55px;
  float: right;
  margin-right: 30px;
}

.conent_1_div_2 ul{
  width: 350px;
  float: right;
}

.conent_1_div_2 ul li p{
  float: left;
  line-height: 30px;
}

.conent_1_div_p{
  width: 252px;
  color: #fff;
  font-size: 14px;
}

.conent_1_div_p1{
  color: #fff;
  font-size: 14px;
}

.conent_1_div_2 li{
  width: 261px;
  height: 80px;
  margin-top: 55px;
  margin-right: 30px;
}

.content2{
  width: 100%;
  height: auto;
}

.content2_1{
  width: 1200px;
  height: 623px;
  margin: 0 auto;
}

.content2_1 h1{
  text-align: center;
  margin: 96px 0 22px 0;
}

.content2_1_ul{
  width: 100%;
  height: 294px;
}

.content2_1_ul li{
  width: 160px;
  height: 294px;
  float: left;
  margin: 0 40px;
  position: relative
}

.content2_1_ul li img{
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content2_1_ul li p{
  text-align: center;
}

.content2_1_ul li p{
  margin-top: 58px;
  font-size: 18px;
  font-weight: 600;
}

.content3{
  width: 100%;
  height: auto;
  background: #D8DCE6;
}

.content3_1{
  width: 1200px;
  height: 560px;
  margin: 0 auto;
}

.content3_1 img{
  margin-top: -20px;
}

.content4{
  width: 100%;
  height: auto;
}

.content4_1{
  width: 1200px;
  height: 737px;
  margin: 0 auto;
}

.content4_1 h1{
  text-align: center;
  margin: 96px 0 4px 0;
}

.content_img{
  float:right;
  margin-bottom: 30px;
}

.content4_ul{
  width: 100%;
  overflow: hidden;
}

.content4_ul li{
  width: 386px;
  height: 408px;
  position: relative;
  float: left;
  margin:  0 0 0 20px;
}

.content4_ul li:first-child{
  margin: 0;
}

.posit{
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content4_ul_div{
  width: 364px;
  height: auto;
  margin: 10px auto;
}

.content4_ul_div img{
  margin-bottom: 30px;
}

.content4_ul_div p{
  color: #fff;
  font-size: 14px;
  line-height: 25px;
}

.content_5{
  width: 100%;
  height: 140px;
  background: #007BFF;
  overflow: hidden;
}

.content_5 p{
  text-align: center;
  margin-top: 20px;
}

.content_5 p:first-child{
  font-size: 24px;
  color: #fff;
}

.content_5 p:last-child{
  width: 280px;
  height: 44px;
  background: #fff;
  text-align: center;
  margin: 0 auto;
  line-height: 44px;
  color: #007BFF;
  border-radius: 25px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Jiejue/Zhengfu.vue